<ngx-legend-chart [legendItems]="chartLegend"></ngx-legend-chart>

<nb-select matRipple class="period-select" [selected]="type" (selectedChange)="changePeriod($event)">
  <nb-option matRipple *ngFor="let period of types" [value]="period">
    {{ period }}
  </nb-option>
</nb-select>
